<template>
  <div v-show="isExpand" :class="['right-container', isExpand ? 'expand-padding' : '']" @wheel.stop="handleWheel">
    <!-- 显示详情 -->
    <detail-box v-show="isShowDetailBox" :isShowDetailBox="isShowDetailBox" />
    <!-- 右侧内容 -->
    <template v-if="!isShowDetailBox">
      <div style="padding: 20px;">
        <calendar-new />
        <el-row :gutter="16" style="margin-top: 28px">
          <el-col :span="12">
            <!--公告-->
            <div
              v-if="modelsList[6].module.status && modelsList[6].list && modelsList[6].list.length"
              class="right-model-container"
            >
              <div class="model-title bottom-line">
                <span class="title">{{ $t("official_notice") }}</span>
                <!-- <div class="right-wrapper">
                  <router-link to="/list?tab=2" class="edit-btn">更多</router-link>
                </div> -->
              </div>
              <div class="right-model-content">
                <template v-for="(item, index) in modelsList[6].list">
                  <a
                    v-if="index < 5"
                    :key="index"
                    :href="getJumpWikiDetailUrl(gameInfo.alias, gameInfo.id, item.id)"
                    class="article-row-tag"
                  >
                    <template v-if="lang == 'en'">
                      <span :class="['span-point', `span-point-${tagList[item.tag || 0].color || 'red'}`]"></span>
                    </template>
                    <template v-else>
                      <span :class="['tag-color', `tag-color-${tagList[item.tag || 0].color || 'red'}`]">{{
                        tagList[item.tag || 0].text
                      }}</span>
                    </template>
                    <span class="title">{{ item.title }}</span>
                  </a>
                </template>
              </div>
              <notice-list-group v-if="false" :list="modelsList[6].list" class="right-model-content" />
            </div>
          </el-col>
          <el-col :span="12">
            <template v-if="modelsList[8].module.status && modelsList[8].list.length">
              <!--     攻略推荐-->
              <div class="right-model-container">
                <div class="model-title bottom-line">
                  <span class="title">游戏攻略</span>
                </div>
                <div class="right-model-content">
                  <template v-for="(item, index) in modelsList[8].list">
                    <a
                      v-if="index < 5"
                      :key="index"
                      :href="getJumpWikiDetailUrl(gameInfo.alias, gameInfo.id, item.origin)"
                      class="article-row-tag"
                    >
                      <span class="time-tag-color">{{ item.origin_detail.updated_at | fromNowTimeFormat }}</span
                      >·
                      <span class="title">{{ item.title }}</span>
                    </a>
                  </template>
                </div>
              </div>
            </template>
            <template v-else-if="lastUpdateList && lastUpdateList.length">
              <!--      词条更新-->
              <div class="right-model-container">
                <div class="model-title bottom-line">
                  <span class="title">{{ $t("entry_update") }}</span>
                </div>
                <div class="right-model-content">
                  <template v-for="(item, index) in lastUpdateList">
                    <a
                      v-if="index < 5"
                      :key="item.id"
                      :href="getJumpWikiDetailUrl(gameInfo.alias, gameInfo.id, item.id)"
                      class="article-row-tag"
                    >
                      <span class="tag-color tag-color-gray">更新</span>
                      <span class="title" v-html="xss(item.title)"></span>
                    </a>
                  </template>
                </div>
              </div>
            </template>
          </el-col>
        </el-row>
        <!--     常用词条-->
        <!-- <div v-if="modelsList[9].module.status" class="right-model-container">
          <div :style="bgStyle('module_img')" class="model-title">
            <span class="title">常用词条</span>
          </div>
          <div class="right-model-content">
            <template v-for="(item,index) in modelsList[9].list">
              <router-link :key="index" :to="item.content_id+'.html'" class="article-item-btn">
                <img v-if="item.icon" :src="item.icon" alt="">
                <span>{{ item.name }}</span>
              </router-link>
            </template>
          </div>
        </div> -->

        <!--      社区-->
        <div class="right-model-container">
          <div class="model-title">
            <span class="title">{{ $t("community") }}</span>
            <div class="right-wrapper">
              <a class="edit-btn" :href="getJumpWikiListUrl(gameInfo.alias, gameInfo.id)">
                <i class="wiki-icon wiki-icon-club mR3"></i>
                <span class="mR3">进入社区</span>
                <i class="el-icon-arrow-right"></i>
              </a>
            </div>
          </div>
          <div class="right-model-content">
            <send-article-box
              v-if="needLogin"
              ref="sendBox"
              :onOk="onSendBoxOk"
              @focus="handleFocusBox"
              :placeholder="loginUid > 0 ? '友善发帖，文明交流' : $t('login_to_post')"
            />
            <div v-if="needLogin" class="H20px"></div>
            <article-item :list="modelsList[7].list" />
            <!-- <template v-for="item in modelsList[7].list">
              <article-list-item :key="item.id" :item="item" layout="row"/>
            </template> -->
            <div class="more-btn">
              <a :href="getJumpWikiListUrl(gameInfo.alias, gameInfo.id)" style="color: #00AFE8">
                <span>进入社区</span>
                <i class="el-icon-arrow-right"></i>
              </a>
            </div>
          </div>
        </div>
      </div>
    </template>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import DetailBox from "./detailBox";
import ArticleItem from "./articleItem";
import CalendarNew from "@/views/wiki/components/calendarNew";
import SendArticleBox from "@/views/wiki/components/sendArticleBox/index.vue";
import NoticeListGroup from "@/views/wiki/components/noticeListGroup";
import { getJumpWikiListUrl, getJumpWikiDetailUrl } from "@/plugins/util";

export default {
  components: {
    DetailBox,
    CalendarNew,
    SendArticleBox,
    NoticeListGroup,
    ArticleItem
  },
  props: {
    isExpand: {
      type: Boolean,
      default: true
    },
    lang: {
      type: String,
      default: ""
    },
    isShowDetailBox: {
      type: Boolean,
      default: false
    },
    modelsList: {
      type: Object,
      default: () => ({})
    },
    tagList: {
      type: Object,
      default: () => ({})
    },
    lastUpdateList: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    ...mapGetters(["gameInfo"])
  },
  methods: {
    getJumpWikiDetailUrl,
    getJumpWikiListUrl,
    handleWheel(event) {
      this.$emit("rightBoxScroll", event);
    },
    onSendBoxOk(data) {
      this.$emit("onSendBoxOk", data);
    },
    clearBox() {
      this.$refs.sendBox.onClear();
    },
    handleFocusBox() {
      if (!this.isLoginShow("")) return false;
      if (!this.isAuthRealName("")) return false;
    }
  }
};
</script>
<style lang="less" scoped>
.right-container {
  flex: 0 0 auto;
  width: calc(50% - 8px);
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
  background-color: #fff;
  border-radius: 8px;
  overflow: auto;
  &.expand-padding {
    // padding: 20px;
  }
  .right-model-container {
    width: 100%;
    background: #fff;
    border-radius: 2px;
    margin-bottom: 8px;
    .article-row-tag {
      display: flex;
      align-items: center;
      overflow: hidden;
      .time-tag-color {
        flex: 0 0 auto;
        margin-right: 4px;
        color: #9f3131;
        font-size: 12px;
        font-weight: 400;
      }
      .title {
        flex: 1;
        margin-left: 4px;
        .ellipsis;
      }
    }

    .model-title {
      display: flex;
      justify-content: space-between;
      align-items: center;
      height: 38px;
      margin-bottom: 10px;
      &.bottom-line {
        margin-bottom: 17px;
        border-bottom: 1px solid #ebebeb;
      }

      .title {
        font-size: 16px;
        font-weight: bold;
        color: #222222;
      }

      .right-wrapper {
        padding-right: 12px;

        .edit-btn {
          display: flex;
          align-items: flex-end;
          font-size: 12px;
          color: @button-bg-color;
        }
      }
    }
    .more-btn {
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 12px;

      a {
        color: @text-basic;
      }
    }
  }
}
</style>
